
import angular from 'angular';
import * as Configuration from '../../app.constants.js';
let moduleName = 'notifications.service';
const HTTP = new WeakMap();

/**
 * Apart from the usual functions exposing backend endpoints,
 * this service is used to communicate between the side nav and the notification controller
 * (the side nav displays the red bullet with the notification count,
 *  but the notification panel must be in an outer div)
 */
export class NotificationsService {
  constructor($http) {
    HTTP.set(this, $http);
    this.openNotificationsFn = null;
    this.updateUnseenNotificationsCountFn = null;
  }

  // called by the notifications controller upon init
  setOpenNotificationsFn(fn) {
    this.openNotificationsFn = fn;
  }

  // called by the sidenav when the red bullet is clicked
  openNotifications() {
    if (this.openNotificationsFn) {
      this.openNotificationsFn();
    }
  }

  // called by the sidenav upon init
  setUpdateUnseenNotificationsCountFn(fn) {
    this.updateUnseenNotificationsCountFn = fn;
  }

  // called by the notifications controller when the count has changed
  updateUnseenNotificationsCount(count) {
    if (this.updateUnseenNotificationsCountFn) {
      this.updateUnseenNotificationsCountFn(count);
    }
  }

  markAsReadAllNotifications(companyId,userId) {
    return HTTP.get(this).post(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/users/' + userId + '/notifications/read-all').then(result => result.data);
  }

  readNotification(companyId,userId,notificationId) {
    return HTTP.get(this).post(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/users/' + userId + '/notifications/' + notificationId + '/read').then(result => result.data);
  }

  getNotifications(companyId,userId,config) {
    let self = this;
    return HTTP.get(self).get(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/users/' + userId + '/notifications',config);
  }

  static NotificationsFactory($http) {
    return new NotificationsService($http);
  }
}
NotificationsService.NotificationsFactory.$inject = ['$http'];

angular
  .module(moduleName, [])
  .factory('NotificationsFactory', NotificationsService.NotificationsFactory);
